module.exports = __webpack_public_path__ + "img/01.14558b20.png";